import React from 'react';
import { Col, DatePicker } from 'antd';
import { I18n } from '@aws-amplify/core';

import { FormItem } from '@/components/ui/Inputs/FormItem';
import { InputDefaultProps } from '../../../types';

export function AnalysisDate({ fieldName, isRequired = false }: Readonly<InputDefaultProps>) {
	return (
		<Col xs={24}>
			<FormItem
				fontSize="1rem"
				isRequired={isRequired}
				title={I18n.get('Analysis date')}
				namePath={[fieldName, 'analysis_date']}
				errorMessage={I18n.get('Enter the date of analysis')}
			>
				<DatePicker
					allowClear
					format="L"
					size="large"
					style={{ width: '100%' }}
					disabledDate={(current) => current && current.valueOf() >= Date.now()}
				/>
			</FormItem>
		</Col>
	);
}
